/**
 * Local static image helpers for WebP + fallback (Phase 4).
 */

const LOCAL_IMAGE_PREFIX = '/images/';

export function isLocalStaticImage(src) {
  return typeof src === 'string' && src.startsWith(LOCAL_IMAGE_PREFIX) && !src.startsWith('http');
}

export function webpSrc(src) {
  if (!isLocalStaticImage(src)) return null;
  if (/\.webp(\?|$)/i.test(src)) return null;
  const q = src.indexOf('?');
  const path = q >= 0 ? src.slice(0, q) : src;
  const dot = path.lastIndexOf('.');
  if (dot <= 0) return null;
  return `${path.slice(0, dot)}.webp${q >= 0 ? src.slice(q) : ''}`;
}

export function defaultHeroImage() {
  return '/images/Doqueve.jpg';
}

export function defaultHeroWebp() {
  return '/images/Doqueve.webp';
}
